document.addEventListener("DOMContentLoaded", function () {
  initTabFeaturedCollection();

  function initTabFeaturedCollection() {
    if (!customElements.get("tab-featured-collection")) {
      customElements.define(
        "tab-featured-collection",
        class TabFeaturedCollection extends HTMLElement {
          constructor() {
            super();
            this.tabs = this.querySelectorAll(
              ".tab_featured_collection_title_item"
            );
            this.tabContent = this.querySelectorAll("slider-component");
            this.tabsContainer = this.querySelector(
              ".tab_featured_collection_content"
            );
          }

          connectedCallback() {
            this.initTabs();
          }

          initTabs() {
            this.tabs.forEach((tab) => {
              tab.addEventListener("click", (e) => this.handleTabClick(e));
            });
          }

          handleTabClick(e) {
            const tab = e.currentTarget;
            const index = [...this.tabs].indexOf(tab);

            this.tabs.forEach((t) => t.classList.remove("tab_item_active"));
            this.tabContent.forEach((c) =>
              c.classList.remove("tab_content_active")
            );
            tab.classList.add("tab_item_active");
            this.tabContent[index].classList.add("tab_content_active");

            this.scrollToCenter(tab); // 居中滚动
          }

          // 始终居中
          scrollToCenter(activeTab) {
            const container = this.tabsContainer;
            const containerRect = container.getBoundingClientRect();
            const tabRect = activeTab.getBoundingClientRect();

            // 计算需要滚动的距离（相对容器坐标系）
            const targetScroll =
              container.scrollLeft +
              (tabRect.left - containerRect.left) -
              containerRect.width / 2 +
              tabRect.width / 2;

            // 计算最大允许滚动位置
            const maxScroll = container.scrollWidth - container.clientWidth;

            // 边界修正
            const clampedScroll = Math.max(
              0,
              Math.min(targetScroll, maxScroll)
            );

            // 执行滚动
            container.scrollTo({
              left: clampedScroll,
              behavior: "smooth",
            });
          }
        }
      );
    }
  }
});
